import { createFileRoute } from '@tanstack/react-router';

import { SlowQueriesTab } from '../../components/SlowQueriesTab';

export const Route = createFileRoute('/db-insights/slow-queries')({
  component: SlowQueriesTab
});
